module.exports = __webpack_public_path__ + "static/media/jacksonville-catering-hero.0958eded.jpg";